var BackOffice = (function(backOffice, $) {

	var events = function() {
			triggerMandatoryFieldBlur();

			$(document).on("submit", "form", function() {
                if (validateForm($(this))) {

                    try {
                        window.postMessage({ eventType:"validation", success: true });
                    } catch (e) {
                    }
                    return true;
                }
                try {
                    window.postMessage({ eventType: "validation", success: false });
                } catch (e) {
                }
				return false;
			});

			$(".numbersOnly").on("keypress", () => {
				return numbersOnlyField(event);
			});
		},
		render = function() {
			populateMandatoryFields();
		},
		validateForm = function(formElement) {
			var validationErrorsExist = false;
			var $elements = $(formElement).find("[data-mandatory]");
			$elements.each(function() {
				var el = $(this).data("mandatory");
				var $el = $("#" + el);
				if ($el.val() == "") {
					validationErrorsExist = true;
					$el
						.addClass("missing")
						.attr("placeholder", "This is a required field");
				} else {
					$el.removeClass("missing").attr("placeholder", "");
				}
			});

			//   this is the new function that we are migrating towards
			$elements = $(formElement).find("input.hybrid-mandatory");
			$elements.each(function() {
				var $el = $(this);
				if (!$el.hasClass("noJSValidate")) {
					// ignore elements with the class noJSValidate as this interferes with postbacks
					if ($el.val() == "") {
						validationErrorsExist = true;
						$el
							.addClass("missing")
							.attr("placeholder", "This is a required field");
					} else {
						$el.removeClass("missing").attr("placeholder", "");
					}
				}
			});

			if (validationErrorsExist) {
			    BackOffice.ToggleLoader(false);
				return false;
			}

			return true;
		},
		validateDateInput = function(value) {
			return Object.prototype.toString.call(value) === "[object Date]";
		},
		validateNumericInput = function(value) {
			return !isNaN(value);
		},
		validateEmailInput = function(value) {
			var filter = /^\s*[\w\-\+_]+(\.[\w\-\+_]+)*\@[\w\-\+_]+\.[\w\-\+_]+(\.[\w\-\+_]+)*\s*$/;
			return String(value).search(filter) != -1;
		},
		populateMandatoryFields = function() {
			$(".hybrid-mandatory").each(function(i) {
				var $that = $(this);
				$that.closest("tr").addClass("IsRequired");
			});
			triggerMandatoryFieldBlur(); //  this is necessary to ensure .net controls have the blur event bound
		},
		populateMandatorySingleField = function($el) {
			$el.addClass("hybrid-mandatory");
			$el.closest("tr").addClass("IsRequired");
		},
		unPopulateMandatorySingleField = function($el) {
			$el.removeClass("hybrid-mandatory");
			$el.closest("tr").removeClass("IsRequired");
		},
		triggerMandatoryFieldBlur = function() {
			$("input.hybrid-mandatory, select.hybrid-mandatory").on(
				"change",
				function() {
					var $that = $(this);

					var value;

					if ($that.hasClass("RadPicker")) {
						value = $that.find("input").val();
					} else {
						value = $that.val();
					}

					if (value === "") {
						$that.closest("tr").addClass("has-error");
					} else {
						$that.closest("tr").removeClass("has-error");
					}
				}
			);
		},
		fieldValidationIsFailing = function($element, isFailing = true) {
			var $parent = $element.closest("tr");
			if ($parent) {
				if (isFailing) {
					$parent.addClass("has-error");
					return;
				}

				$parent.removeClass("has-error");
			}
			return;
		},
		isEmailValid = function($el) {
			var emailtext = $el.val();

			var regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i;

			if (emailtext === "") {
				return false;
			} else if (!regex.test(emailtext)) {
				return false;
			}

			return true;
		},
		/**
		 * Validate a native Telerik date picker value and apply/remove backOffice validation styling
		 * Usage is via <ClientEvents> property of telerik:RadDatePicker
		 * eg:     <ClientEvents OnDateSelected="BackOffice.ValidateTelerikDatePicker"></ClientEvents>
		 * @param {any} sender  argument passed by Telerik
		 * @param {any} e       argument passed by Telerik
		 */
		validateTelerikDatePicker = function(sender, e) {
			let elementId = sender.get_id(),
				dateSelected = e.get_newDate(),
				el = document.getElementById(elementId),
				parent = $(el).closest(".IsRequired").get(0);

			if (parent == null) {
				//  this field must not be mandatory - doofus
				return;
			}

			if (parent && !dateSelected) {
				parent.classList.add("has-error");
				return;
			}

			parent.classList.remove("has-error");
		},
		numbersOnlyField = function(evt) {
			evt = evt ? evt : window.event;
			var charCode = evt.which ? evt.which : evt.keyCode;
			if (charCode > 31 && (charCode < 48 || charCode > 57)) {
				return false;
			}
			return true;
		},
        containHtml = function (text){
            var matched = text.match(/<[a-zA-Z]/);
            return matched != null;
        };

    var customValidators = {
        DateGreaterThanNow: function (sender, args){
            if (args.Value && (args.Value !== "")) {
                var val = parseRadDateTime(args.Value);
                var now = new Date();

                args.IsValid = val > now;
                return;
            }

            args.IsValid = true;
        }
    };

    backOffice.Module({
        name: "Form Validation",
        init: function() {
            events();
            render();
        }
    });

	return $.extend(backOffice, {
		ValidateForm: function(formElement) {
			return validateForm(formElement);
		},
		ValidateDateInput: function(value) {
			return validateDateInput(value);
		},
		ValidateEmailInput: function(value) {
			return validateEmailInput(value);
		},
		ValidateNumericInput: function(value) {
			return validateNumericInput(value);
		},
		PopulateMandatoryFields: function() {
			populateMandatoryFields();
		},
		TriggerMandatoryFieldBlur: function() {
			triggerMandatoryFieldBlur();
		},
		PopulateMandatorySingleField: function($el) {
			populateMandatorySingleField($el);
		},
		UnpopulateMandatorySingleField: function($el) {
			unPopulateMandatorySingleField($el);
		},
		IsEmailValid: function($el) {
			return isEmailValid($el);
		},
		ValidateTelerikDatePicker: validateTelerikDatePicker,
		FieldValidationIsFailing: function($formElement, isValidationFailing) {
			return fieldValidationIsFailing($formElement, isValidationFailing);
		},
        CustomValidators: customValidators,
        ContainHtml: function (text) {
            return containHtml(text);
		},
		IsNumbersOnlyField: function (event) {
			return numbersOnlyField(event);
		}
	});
})(BackOffice || {}, jQuery);
